var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56093_78687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6775 3.94078C15.8039 3.88562 15.9404 3.85715 16.0783 3.85716C16.2162 3.85716 16.3527 3.88565 16.4791 3.94083C21.4195 6.10062 26.132 8.74815 30.5465 11.844C30.7021 11.9532 30.8234 12.1043 30.8964 12.2797C30.9693 12.4552 30.9909 12.6478 30.9585 12.835C30.9261 13.0223 30.8412 13.1965 30.7136 13.3373C30.586 13.4781 30.421 13.5797 30.2378 13.6302C25.6545 14.8958 21.2195 16.6476 17.0086 18.8558L17.0045 18.8585C16.8522 18.9386 16.7013 19.0174 16.5503 19.0989C16.405 19.1766 16.2428 19.2172 16.078 19.2172C15.9133 19.2172 15.7511 19.1765 15.6058 19.0989C13.7998 18.1349 11.9512 17.253 10.0656 16.4559L10.0656 16.1567C10.0656 15.9817 10.1551 15.8254 10.2954 15.7412C12.312 14.5193 14.3866 13.3959 16.512 12.3749C16.7515 12.2598 16.9355 12.0542 17.0234 11.8034C17.1114 11.5526 17.0961 11.2771 16.981 11.0376C16.8658 10.7981 16.6603 10.6141 16.4095 10.5261C16.1587 10.4382 15.8832 10.4535 15.6437 10.5686C13.4603 11.6176 11.3291 12.7718 9.25747 14.0271C8.96274 14.2058 8.70848 14.444 8.51088 14.7265C8.31327 15.0089 8.17667 15.3294 8.10976 15.6676C6.08072 14.8867 4.01463 14.2058 1.91893 13.6272C1.73576 13.5766 1.57076 13.4749 1.44316 13.3341C1.31557 13.1933 1.23065 13.0191 1.19831 12.8319C1.16597 12.6446 1.18754 12.452 1.26051 12.2766C1.33348 12.1011 1.45484 11.95 1.61042 11.8409C6.02496 8.74614 10.7373 6.09965 15.6775 3.94078Z",
    fill: "url(#paint0_linear_56093_78687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4934 20.8651C20.775 19.1122 24.2017 17.6454 27.7353 16.4811C27.9142 18.3702 28.029 20.2793 28.0757 22.2045C28.0808 22.4063 28.0249 22.6049 27.9152 22.7744C27.8056 22.9439 27.6472 23.0763 27.461 23.1543C23.6738 24.7358 20.0476 26.6781 16.6325 28.9545C16.4679 29.0642 16.2745 29.1227 16.0767 29.1227C15.8789 29.1227 15.6856 29.0641 15.521 28.9544C12.1067 26.6777 8.48112 24.7349 4.69452 23.1529C4.50829 23.0752 4.34986 22.9431 4.23998 22.7738C4.1301 22.6045 4.07388 22.4061 4.07869 22.2043C4.12557 20.2778 4.24058 18.3701 4.41972 16.4783C5.65013 16.8845 6.86452 17.3255 8.06153 17.8012L8.06143 19.4979C7.77276 19.6642 7.5301 19.8998 7.3554 20.1835C7.18071 20.4671 7.07949 20.7899 7.0609 21.1225C7.04231 21.4551 7.10694 21.7871 7.24894 22.0885C7.39095 22.3899 7.60584 22.6511 7.87418 22.8485C7.75391 23.3562 7.57753 23.8545 7.34371 24.3314C7.94755 24.616 8.54739 24.9113 9.14189 25.2133C9.47705 24.5316 9.72444 23.8102 9.87815 23.0664C10.216 22.9162 10.5057 22.6754 10.7152 22.3708C10.9248 22.0662 11.0459 21.7095 11.0653 21.3403C11.0847 20.971 11.0015 20.6036 10.8251 20.2787C10.6486 19.9538 10.3857 19.6841 10.0654 19.4993L10.0655 18.6376C11.626 19.3194 13.1591 20.0625 14.6611 20.865C15.0968 21.0977 15.5832 21.2195 16.0772 21.2195C16.5712 21.2196 17.0576 21.0979 17.4934 20.8651Z",
    fill: "url(#paint1_linear_56093_78687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00627 26.1937C6.56742 25.6339 7.01234 25.0047 7.34237 24.3301C7.94755 24.616 8.54739 24.9113 9.14189 25.2146C8.7047 26.1025 8.12418 26.9122 7.42367 27.6113C7.23371 27.7882 6.98248 27.8846 6.72289 27.88C6.46331 27.8754 6.21565 27.7702 6.03208 27.5866C5.84851 27.403 5.74336 27.1553 5.7388 26.8958C5.73423 26.6362 5.8306 26.385 6.00761 26.195L6.00627 26.1937Z",
    fill: "url(#paint2_linear_56093_78687)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56093_78687",
    x1: 16.4389,
    y1: 3.03094,
    x2: 14.4605,
    y2: 28.9748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.77
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_56093_78687",
    x1: 16.4389,
    y1: 3.03094,
    x2: 14.4605,
    y2: 28.9748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.77
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_56093_78687",
    x1: 16.4389,
    y1: 3.03094,
    x2: 14.4605,
    y2: 28.9748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.77
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56093_78687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0636,
    height: 32.0636,
    fill: "white",
    transform: "translate(0.0466309 0.192383)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/cap.f825361b5510a7baca30d8338396d511.svg";
export { ForwardRef as ReactComponent };